import * as React from "react";
import { Card } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";


const styles = (theme: any) => {
  const primary = theme.palette.primary;
  const secondary = theme.palette.secondary;

  return {
    card: {
      padding: 60,
      width: 672,
      position: "relative",
      height: 450,
      display: "flex",
      flexDirection: "row",
      fontFamily: "Roboto",
      background: "rgba(21, 21, 21, 0.85)",
      //border: "1px solid #393939",
      boxSizing: "border-box",
      boxShadow: "0px 12px 20px rgba(31, 31, 38, 0.25)",
      borderRadius: 4
    },
    glow: {
      zIndex: 0,
      height: 400,
      width: 400,
      position: "absolute",
      backgroundImage: `radial-gradient(${convertHex(primary.light, 0.3)} 0%, ${convertHex(primary.dark, 0)} 65%)`,
      top: -51,
      left: -52
    },
    productName: {
      fontFamily: "Roboto",
      fontStyle: "normal",
      fontWeight: 300,
      lineHeight: "normal",
      fontSize: 64,
      color: "#BCBCBC"
    },
    mainScreen: {
      height: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    action: {
      fontFamily: "Roboto",
      fontStyle: "normal",
      fontWeight: 300,
      lineHeight: "normal",
      fontSize: 36,
      color: secondary.main
    },
    backgroundImg: {
      // minHeight: "100%",
      // minWidth: "1024px",
      width: "100%",
      // height: "auto",
      position: "fixed",
      top: 0,
      left: 0,
      zIndex: "-900"
    },
    backgroundLinks: {
      //opacity: 0.4,
      animation: "display 2s ease 0s 1 normal forwards"
    },
    backgroundAttack: {
      opacity: 0,
      animation: "clip 8s ease 2s infinite"
      //animationDuration: "4s"
    },
    logo: {
      height: 43,
      alignContents: "center",
      float: "center"
    },
    container: {
      padding: 32
    },
    metaContainer: {
      display: "flex",
      flexDirection: "column",
      padding: 32,
      zIndex: 1
    },
    label: {
      opacity: 0.9,
      position: "absolute",
      width: 100,
      height: 300,
      left: 120,
      top: 0,
      display: "flex",
      flexDirection: "column",
      paddingBottom: 24,
      background: `linear-gradient(-180deg, rgba(17, 26, 58, 0) 0%, ${secondary.dark} 70%)`, "& div": {
        transform: "rotate(-90deg)",
        color: "#8a8a8a",
        fontFamily: "Roboto",
        fontStyle: "normal",
        fontWeight: 300,
        lineHeight: "normal",
        fontSize: 64
      }
    },
    divider: { 
      width: 1, 
      background: "#ffffff33", 
      margin: "0 20px" 
    }
  };
};

interface ScreenProps {
  classes?: any;
  backgroundUrl: string;
  logoUrl: string;
  productName: string;
  action: string;
  form: any;
}

const w: any = withStyles;

@w(styles)
export class Screen extends React.Component<ScreenProps> {
  render() {
    const {
      classes,
      backgroundUrl,
      logoUrl,
      form,
      productName,
      action
    } = this.props;

    return (
      <div className={classes.mainScreen}>
        <img 
          className={classes.backgroundImg} 
          src={backgroundUrl}
          alt="background-sky-image"
        />

        <img
          className={`${classes.backgroundImg} ${classes.backgroundLinks}`}
          src="images/login-background-links.png"
          alt="login-background-links.png"
        />

        <img
          className={`${classes.backgroundImg} ${classes.backgroundAttack}`}
          src="images/login-background-attack.png"
          alt="login-background-attack.png"
        />

        <div className={classes.label}>
          <span style={{ flex: 1 }} />
          <div>{action}</div>
        </div>

        <Card className={classes.card}>
          <div className={classes.glow} />
          <div className={classes.metaContainer}>
            <div className={classes.productName}>{productName}</div>
            <div className={classes.action}>{action}</div>
            <span style={{ flex: 1 }} />
            <img className={classes.logo} src={logoUrl} />
          </div>
          <div className={classes.divider} />
          <div className={classes.container}>{form}</div>
        </Card>
      </div>
    );
  }
}

function convertHex(hex: string, opacity: number) {
  hex = hex.replace("#", "");
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  return `rgba(${r},${g},${b},${opacity})`;
}
